var map = {
	"./about.json": [
		7102,
		102
	],
	"./contact.json": [
		1623,
		623
	],
	"./how-it-works.json": [
		6578,
		578
	],
	"./leagues-we-cover.json": [
		1106,
		106
	],
	"./methodology.json": [
		4948,
		948
	],
	"./privacy-policy.json": [
		1572,
		572
	],
	"./terms.json": [
		8488,
		488
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3212;
module.exports = webpackAsyncContext;